import { loadItem, saveItem, deleteItem } from "./storage";

export const storage = {
  load: loadItem,
  save: saveItem,
  delete: deleteItem,
};
